import { apiFetch } from '../lib/apiFetch';
import {
  DismissReason,
  GiveBackResult,
  IntakeFacts,
  LinkSearchResult,
  LinkSuggestion,
  TakeOverResult,
  TransportItem,
} from './types';

const BASE = 'answering-service/transport';

const post = (path: string, body?: unknown) =>
  apiFetch(`${BASE}/${path}`, {
    method: 'POST',
    body: body === undefined ? undefined : JSON.stringify(body),
  });

const enc = encodeURIComponent;

export async function fetchTransportWaiting(
  funeralId?: number,
): Promise<TransportItem[]> {
  const qs = funeralId ? `?funeralId=${funeralId}` : '';
  const res = await apiFetch(`${BASE}/waiting${qs}`);
  return res?.items || [];
}

export async function takeOver(id: string): Promise<{
  result: TakeOverResult;
  at?: string | null;
  by?: string | null;
  destination?: string | null;
}> {
  return post(`${enc(id)}/take-over`);
}

export async function giveBack(id: string): Promise<{ result: GiveBackResult }> {
  return post(`${enc(id)}/give-back`);
}

export async function fetchLinkSuggestions(
  id: string,
): Promise<{ intake: IntakeFacts | null; suggestions: LinkSuggestion[] }> {
  const res = await apiFetch(`${BASE}/${enc(id)}/link/suggestions`);
  return { intake: res?.intake ?? null, suggestions: res?.suggestions || [] };
}

export async function searchLinkTargets(q: string): Promise<LinkSearchResult[]> {
  const res = await apiFetch(`${BASE}/link/search?q=${enc(q)}`);
  return res?.results || [];
}

export async function linkIntake(
  id: string,
  target: { funeralId?: number; leadId?: string },
): Promise<{ ok: boolean; funeralId: number | null; leadId: string | null }> {
  return post(`${enc(id)}/link`, target);
}

export async function createCaseFromIntake(id: string): Promise<{ funeralId: number }> {
  return post(`${enc(id)}/create-case`);
}

export async function dismissIntake(
  id: string,
  reason: DismissReason,
  note?: string,
): Promise<{ result: 'dismissed' | 'already_dispatched' | 'not_found' }> {
  return post(`${enc(id)}/dismiss`, { reason, note: note || undefined });
}

export async function restoreIntake(
  id: string,
): Promise<{ result: 'restored' | 'not_dismissed' | 'not_found' }> {
  return post(`${enc(id)}/restore`);
}
